// extracted by mini-css-extract-plugin
export default {"notify":"notify-tOex5O","icon":"icon-yUUtCW","overlay":"overlay-sslKjE"};